//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Emitter from '@/mixins/emitter';

export default {
  name: 'DpRadio',
  mixins: [Emitter],
  props: {
    value: { type: [String, Number], default: null },
    val: { type: null, default: null },
    label: { type: String, default: null },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      focus: false,
    };
  },
  computed: {
    model: {
      get() {
        return this.isGroup ? this.radioGroup.value : this.value;
      },
      set(val) {
        if (this.isGroup) {
          this.dispatch('DpRadioGroup', 'input', [val]);
        } else {
          this.$emit('input', val);
        }
      },
    },
    isGroup() {
      return !!this.radioGroup;
    },
    isChecked() {
      if (this.model === this.val) {
        return true;
      }

      return false;
    },
    isDisabled() {
      return this.isGroup
        ? this.radioGroup.disabled || this.disabled
        : this.disabled;
    },
    tabIndex() {
      return this.isDisabled ? -1 : 0;
    },
  },
  created() {
    let parent = this.$parent;
    while (parent) {
      if (parent.$options.name !== 'DpRadioGroup') {
        parent = parent.$parent;
      } else {
        this.radioGroup = parent;
      }
    }
  },
  methods: {
    handleChange() {
    },
  },
};
